import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  loadingBoxDateJoined: {
    height: 35,
    width: 170,
    marginBottom: indent / 4,
  },
  headerContainer: {
    marginTop: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  header: {
    marginBottom: indent,
  },
  orderContainer: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    paddingVertical: indent,
    marginHorizontal: indent,
    paddingHorizontal: 0,
  },
  orderLine1: {
    flex: 1,
    flexDirection: 'row',
  },
  orderDate: {
    flex: 1,
  },
  orderAmount: {
    flex: 0,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  orderAmountEmptyText: {
    ...getFontFamily('bold'),
  },
});
